import classNames from "classnames";
import React from "react";

import css from "../ey_pptx_preview.module.scss";

type FieldProps = {
  text?: string;
  title: string;
  className?: string;
  titleClassName?: string;
  textClassName?: string;
  children?: React.ReactNode;
};
export const Field = ({ text, title, className, titleClassName, textClassName, children }: FieldProps) => (
  <div className={classNames(css.field, className)}>
    <div className={classNames(css.subheader, titleClassName)}>{title}</div>
    <div className={classNames(css.text, textClassName)}>{text || children}</div>
  </div>
);
